import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Dialog, DialogActions, DialogBody, DialogTitle } from '../../catalyst/dialog';
import { Button } from '../../catalyst/button';
import type { UserListItem } from '@avisoma/shared';
import backend from '../../services/backend';

export function DeactivateUserDialog({
  user,
  open,
  onClose,
}: {
  user: UserListItem | null;
  open: boolean;
  onClose: () => void;
}) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: () => backend.deactivateUser(user!.id).then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
      onClose();
    },
  });

  if (!user) return null;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Deactivate {user.username}?</DialogTitle>
      <DialogBody>
        <p className="text-sm text-zinc-700 dark:text-zinc-300">
          They won&apos;t be able to log in. Their history is preserved and you can reactivate them anytime.
        </p>
      </DialogBody>
      <DialogActions>
        <Button plain onClick={onClose}>
          Cancel
        </Button>
        <Button color="red" onClick={() => mutation.mutate()} disabled={mutation.isPending}>
          {mutation.isPending ? 'Deactivating…' : 'Deactivate'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
